module.exports = __webpack_public_path__ + "img/014-image.fde800d6.svg";